import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Storage } from '@ionic/storage-angular';
import { PubSubConstants } from '@zlib/config/pubsub.constants';
import { PubSubService } from '@zlib/services/pubsub.services';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.html',
    styleUrl: './app.scss'
})
export class App {
    constructor(
        private readonly pubsub: PubSubService,
        private readonly router: Router,
        private readonly storage: Storage
    ) {}
    ngOnInit(): void {
        this.storage.create();

        this.pubsub
            .$sub(PubSubConstants.EVENTS.REDIRECT_ROUTE)
            .subscribe((returnUrl: string) => {
                this.router.navigate([returnUrl]);
            });
    }
}
